/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_PublishedInputs */

const en_statement_taxonomy_editor_published = /** @type {(inputs: Statement_Taxonomy_Editor_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classification template published`)
};

const nl_statement_taxonomy_editor_published = /** @type {(inputs: Statement_Taxonomy_Editor_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificatiesjabloon gepubliceerd`)
};

/**
* | output |
* | --- |
* | "Classification template published" |
*
* @param {Statement_Taxonomy_Editor_PublishedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_published = /** @type {((inputs?: Statement_Taxonomy_Editor_PublishedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_PublishedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_published(inputs)
	return en_statement_taxonomy_editor_published(inputs)
});